import { Flex } from '@chakra-ui/react';
import { useReviewCreationV1Data } from 'reducers/reviewCreationV1Slice';

import { ArrowForward } from 'assets/assetsV1/iconComponents/ArrowForward';

import { Button } from 'uiToolkitV1/Button';

import { REVIEW_PRESET_TYPES } from './ReviewProcessV2Presets';
import { useCreateNewPresetReviewMutation, useCreateNewReviewMutation } from './dataHooks/nameAndRevieweesSectionHooks';

export const ReviewProcessV2PresetsFooter = () => {
  const { selectedReviewCreationPreset } = useReviewCreationV1Data();

  const { mutate: createReviewCycle, isLoading: createReviewIsLoading } = useCreateNewReviewMutation();

  const { mutate: createReviewCycleWithPreset, isLoading: createReviewWithPresetIsLoading } =
    useCreateNewPresetReviewMutation();
  const handleNextClick = () => {
    createReviewCycleWithPreset({ preset: selectedReviewCreationPreset });
  };

  const isCreating = createReviewIsLoading || createReviewWithPresetIsLoading;

  return (
    <Flex
      py={3}
      px={4}
      justifyContent="flex-end"
      alignItems="center"
      bg="surface.F5F7F9"
      borderTop="1px solid"
      borderColor="border.CFD7DF"
      borderBottomRadius="8px"
    >
      <Button
        onClick={handleNextClick}
        disabled={isCreating || !selectedReviewCreationPreset}
        StartIcon={isCreating ? null : ArrowForward}
      >
        {isCreating ? 'Creating ...' : 'Next'}
      </Button>
    </Flex>
  );
};
